import React from "react";
import Modal from "react-bootstrap/Modal";
import "./idPhotoPopup.css";
import { baseURL } from "../../api/Axios";
import CloseIcon from "../../assets/images/Icons/closeIcon.svg";
import BackArrow from "../../assets/images/Icons/backArrowsvg.svg";
import FrontArrow from "../../assets/images/Icons/frontArrow.svg";
import { Row, Col } from "react-bootstrap";
const IdPhotoPopup = ({
  show,
  setShow,
  handleSubmit = () => setShow(false),
  idproof,
}) => {
  var imgPath = `${baseURL}/images/${idproof} `;
  // let filename = idproof;
  // let extension = filename.split(".").pop();
  //
  const getExtension = (idproof) => {
    return "." + idproof?.split(".").pop();
  };

  let extension = getExtension(idproof);

  return (
    <div className="idPhotoPopupConatiner">
      <Modal show={show} className="IdProofPopuBox">
        <Modal.Body>
          <div className="outerModalContainerPopUp">
            <div className="popupInenerBox">
              <div>
                <div
                  className="closeButtonpopupId"
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  <img className="btnClosePopUp" src={CloseIcon} alt="Close" />
                </div>

                {getExtension(idproof).toLowerCase() === ".pdf" ? (
                  <iframe
                    className="iframe-section"
                    src={imgPath}
                    height="100%"
                    width="100%"
                  ></iframe>
                ) : (
                  <div className="popupMainImgContiner">
                    <img
                      className="imagShowId"
                      src={imgPath}
                      width="35px"
                      height="40px"
                    />
                  </div>
                )}
              </div>
              {/* <div>
                <Row className="button-align">
                  <Col>
                    <img src={BackArrow} />
                    <img src={FrontArrow} />
                  </Col>
                </Row>
              </div> */}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default IdPhotoPopup;
